import { render, staticRenderFns } from "./SingleChoiceQuestion.vue?vue&type=template&id=08138b69&scoped=true"
import script from "./SingleChoiceQuestion.vue?vue&type=script&lang=js"
export * from "./SingleChoiceQuestion.vue?vue&type=script&lang=js"
import style0 from "./SingleChoiceQuestion.vue?vue&type=style&index=0&id=08138b69&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08138b69",
  null
  
)

export default component.exports